import {getParams, isInApp} from "@/common/utils/tools";

export class Sense {
    static initPromise

    static async init({product_id,app_id,app_version}) {
        const {sense, mmc} = (window as any);
        if (!sense) return;

        if (isInApp()) {
            if (!mmc.afterReady) {
                await new Promise(resolve => {
                    mmc.ready(resolve);
                });
            }
        }

        const channel = getParams('channel') || localStorage.getItem('channel') || '';
        const object = {
            app_id:app_id|| 'S49', // 业务线id
            product_id:product_id|| '159714467600000010',
            channel, // 渠道号
            single_page: true, // 是否单页应用
            attr: {
                $app_version:app_version|| 'H5-live',
            },
            auto_track: true,
            user_center_id: getParams('u_id') || '',
            show_log: false // 发送数据时，是否在控制台显示日志信息
            // env: "", // 环境 台湾 tw 美国 mx
        };

        sense.init(object);

        this.initPromise = new Promise(resolve => {
            function waitInit() {
                if (sense._status === 'fulfill') {
                    resolve();
                    return;
                }
                setTimeout(waitInit, 100);
            }

            waitInit();
        });
    }

    static async track(eventName, properties = {}) {
        const {sense} = window as any;

        await this.initPromise;

        return sense.track(eventName, {
            source: location.href,
            ...properties,
        });
    }
}
